export default __webpack_public_path__ + "static/schwierigkeitsgrad-full-2be1d321c8c23e590cbc312dd6314241.svg";